import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "spinner", "buttonText"]

  connect() {
    this.frame = document.getElementById("search_results")
    this.hideLoading = this.hideLoading.bind(this)
    this.handlePopState = this.handlePopState.bind(this)

    if (this.frame) {
      this.frame.addEventListener("turbo:frame-render", this.hideLoading)
      this.frame.addEventListener("turbo:frame-load", this.hideLoading)
    }

    window.addEventListener("popstate", this.handlePopState)
  }

  disconnect() {
    if (this.frame) {
      this.frame.removeEventListener("turbo:frame-render", this.hideLoading)
      this.frame.removeEventListener("turbo:frame-load", this.hideLoading)
    }

    window.removeEventListener("popstate", this.handlePopState)
  }

  choose(event) {
    event.preventDefault()
    const query = event.params.query

    if (this.hasInputTarget) {
      this.inputTarget.value = query
      this.inputTarget.focus()
    }

    this.updateLocation(query)
    this.setLoading(true)

    if (this.frame) {
      this.loadFrame(query)
    } else {
      this.element.requestSubmit()
    }
  }

  showLoading() {
    this.updateLocation(this.currentQuery())
    this.setLoading(true)
  }

  hideLoading() {
    this.setLoading(false)
  }

  currentQuery() {
    return this.hasInputTarget ? this.inputTarget.value.trim() : ""
  }

  updateLocation(query) {
    const url = new URL(window.location.href)
    const actionUrl = new URL(this.element.action, window.location.origin)

    url.pathname = actionUrl.pathname
    if (query) {
      url.searchParams.set("q", query)
    } else {
      url.searchParams.delete("q")
    }

    if (url.toString() !== window.location.href) {
      window.history.pushState({}, "", url.toString())
    }
  }

  handlePopState() {
    const query = new URL(window.location.href).searchParams.get("q") || ""

    if (this.hasInputTarget) this.inputTarget.value = query
    if (this.frame) {
      this.setLoading(true)
      this.loadFrame(query)
    }
  }

  loadFrame(query) {
    const url = new URL(this.element.action, window.location.origin)
    if (query) url.searchParams.set("q", query)
    this.frame.src = url.toString()
  }

  setLoading(isLoading) {
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.toggle("d-none", !isLoading)
    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.textContent = isLoading ? "Searching" : "Search"
    }
  }
}
